var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useField } from 'formik';
import DecimalField from '../forms/DecimalField';
export default (function (_a) {
    var props = __rest(_a, []);
    var _b = useField(props), field = _b[0], meta = _b[1], fieldHelper = _b[2];
    var changed = function (value) {
        fieldHelper.setValue(value);
    };
    return (React.createElement(DecimalField, __assign({}, props, { onBlur: field.onBlur, onChange: changed, value: field.value, errorMessage: meta.error })));
});
